import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlags, type FeatureKey } from '@/contexts/FeatureFlagContext';

interface FeatureRouteProps {
  featureKey: FeatureKey;
  children: ReactNode;
}

export function FeatureRoute({ featureKey, children }: FeatureRouteProps) {
  const { isEnabled, isLoading } = useFeatureFlags();

  // While loading flags, show nothing (prevent flash)
  if (isLoading) return null;

  if (!isEnabled(featureKey)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
